import { render, staticRenderFns } from "./ScoreSetOverflowMenu.vue?vue&type=template&id=312daf3c"
import script from "./ScoreSetOverflowMenu.vue?vue&type=script&lang=js"
export * from "./ScoreSetOverflowMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports